import React, { useId } from 'react';
import { Label } from './ui/label';
import { cn } from '../lib/utils';

/**
 * Label + control + hint/error. Errors are only ever shown after the customer
 * has tried to move on — a form that turns red while you are still typing your
 * own phone number reads as an accusation.
 */
const Field = ({ label, hint, error, required, className, children }) => {
  const id = useId();

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <Label htmlFor={id}>
        {label}
        {required && <span className="ml-0.5 text-muted-foreground">*</span>}
      </Label>

      {typeof children === 'function' ? children({ id, 'aria-invalid': Boolean(error) }) : children}

      {error ? (
        <p className="text-xs text-destructive">{error}</p>
      ) : hint ? (
        <p className="text-xs text-muted-foreground">{hint}</p>
      ) : null}
    </div>
  );
};

export default Field;
